// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.bs.mjs";
import * as Core__JSON from "@rescript/core/lib/es6/src/Core__JSON.bs.mjs";
import * as Core__Result from "@rescript/core/lib/es6/src/Core__Result.bs.mjs";

function box(x) {
  return {
          TAG: "Box",
          _0: x
        };
}

function unbox(x) {
  return x._0;
}

function map(x, f) {
  return {
          TAG: "Box",
          _0: f(x._0)
        };
}

function jsonCodec(valueCodec) {
  return Jzon.custom((function (boxedValue) {
                var json = Jzon.encodeWith(boxedValue._0, valueCodec);
                return Object.fromEntries([[
                              "box",
                              json
                            ]]);
              }), (function (json) {
                var dict = Core__JSON.Classify.classify(json);
                if (typeof dict === "object" && dict.TAG === "Object") {
                  var json$1 = dict._0["box"];
                  if (json$1 !== undefined) {
                    return Core__Result.map(Jzon.decodeWith(json$1, valueCodec), box);
                  } else {
                    return {
                            TAG: "Error",
                            _0: {
                              NAME: "MissingField",
                              VAL: [
                                [],
                                "box"
                              ]
                            }
                          };
                  }
                }
                return {
                        TAG: "Error",
                        _0: {
                          NAME: "UnexpectedJsonType",
                          VAL: [
                            [],
                            "object",
                            json
                          ]
                        }
                      };
              }));
}

export {
  box ,
  unbox ,
  map ,
  jsonCodec ,
}
/* No side effect */
